import { Field } from '@nestjs/graphql'
import { BaseGetArgs } from '../base/baseGet.args'
import { ArgsType } from '@nestjs/graphql'

@ArgsType()
export class NotificationGetArgs extends BaseGetArgs<NotificationGetArgs> {
  @Field(t => [String], { nullable: true })
  notificationCodes?: string[]

  @Field({ nullable: true })
  unread?: Boolean
}
